let LOCAL_API_PATH = 'https://vigapiv1.vignets.com/';
let LOCAL_BUILDER_PATH = 'https://agency.vignets.com/builder/index.html?';
let LOCAL_PUB_PLAYER_PATH = 'https://a.vignets.com/player/';
let LOCAL_UNPUB_PLAYER_PATH = 'https://a.vignets.com/player/?';

if(window.location.hostname === 'localhost') {
    // LOCAL_API_PATH= 'http://localhost/vignets_api/public/';
    LOCAL_API_PATH= 'https://devvigapiv1.vignets.com/';
    LOCAL_BUILDER_PATH = 'https://devagency.vignets.com/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://devagency.vignets.com/player/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://devagency.vignets.com/player/?';
}
else if(window.location.hostname === 'devagency.vignets.com') {
    LOCAL_API_PATH= 'https://devvigapiv1.vignets.com/';
    LOCAL_BUILDER_PATH = 'https://devagency.vignets.com/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://devagency.vignets.com/player/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://devagency.vignets.com/player/?';
}
else if(window.location.hostname === 'seo.vignets.com' || window.location.hostname === 'seo.vignets.com:8080' ) {
    LOCAL_API_PATH= 'https://devvigapiv1.vignets.com/';
    LOCAL_BUILDER_PATH = 'https://seo.vignets.com:8080/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://seo.vignets.com:8080/player/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://seo.vignets.com:8080/player/?';
}
else{
    LOCAL_API_PATH= 'https://vigapiv1.vignets.com/';
    LOCAL_BUILDER_PATH = 'https://agency.vignets.com/builder/index.html?';
    LOCAL_PUB_PLAYER_PATH = 'https://a.vignets.com/player/';
    LOCAL_UNPUB_PLAYER_PATH = 'https://a.vignets.com/player/?';
}

export const API_PATH = LOCAL_API_PATH;
export const BUILDER_PATH = LOCAL_BUILDER_PATH;
export const PUB_PLAYER_PATH = LOCAL_PUB_PLAYER_PATH;
export const UNPUB_PLAYER_PATH = LOCAL_UNPUB_PLAYER_PATH;

console.log(window.location.hostname);

export const  IMG_PATH = 'https://s3cdn.vignets.com/';
export const  IMGIX_PATH = 'https://vignets.imgix.net/';



export const  BUCKET_NAME = 'lexplainer';
export const  ALBUM_NAME = 'assets/slider';
export const  REGION = 'us-east-1';
export const  ACCESS_KEY_ID = 'AKIAIAEQKI43QMFTGF7A';
export const  SECRET_ACCESS_KEY = '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';



// WEBPACK FOOTER //
// ./src/constants/index.js